<template>
  <div v-if="items.length">
    <v-menu offset-y>
      <template v-slot:activator="{ on }">
        <v-btn
          small
          flat
          class="ma-0 px-1 text-none caption"
          :color="activatorColor"
          v-on="on"
          @dblclick.stop
        >
          {{ title }}
          <v-icon v-if="hasInactive" small right color="error">mdi-alert</v-icon>
          <v-icon small right>mdi-chevron-down</v-icon>
        </v-btn>
      </template>
      <v-list two-line>
        <v-list-tile
          v-for="entry in decoratedItems"
          :key="entry.key"
        >
          <v-list-tile-avatar>
            <v-progress-circular
              v-if="entry.isLoading"
              indeterminate
              size="20"
              width="2"
              color="primary"
            ></v-progress-circular>
            <v-tooltip v-else top>
              <template v-slot:activator="{ on }">
                <v-icon :color="entry.statusColor" v-on="on">{{ entry.statusIcon }}</v-icon>
              </template>
              <span>{{ entry.statusTooltip }}</span>
            </v-tooltip>
          </v-list-tile-avatar>
          <InitiativeDisplay
            v-if="entry.hasInitiative"
            :initiative="entry.initiative"
            hide-broker
          ></InitiativeDisplay>
          <v-list-tile-content v-else>
            <v-list-tile-title class="grey--text">{{ entry.placeholder }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import InitiativeDisplay from "@/components/ui/InitiativeDisplay.vue";

const STATUS_LOADING = {
  statusIcon: "",
  statusColor: "",
  statusTooltip: "",
};

const STATUS_FAILED = {
  statusIcon: "mdi-help-circle",
  statusColor: "grey",
  statusTooltip: "Não foi possível carregar esta iniciativa",
};

const STATUS_INACTIVE = {
  statusIcon: "mdi-alert-circle",
  statusColor: "error",
  statusTooltip: "Iniciativa inativa: não será enviada",
};

const STATUS_ACTIVE = {
  statusIcon: "mdi-check-circle",
  statusColor: "success",
  statusTooltip: "Iniciativa ativa",
};

export default {
  name: "FallbackInitiativesDisplay",
  components: {
    InitiativeDisplay,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    title() {
      return `Iniciativas alternativas (${this.items.length})`;
    },
    hasInactive() {
      return this.items.some((entry) => entry.isInactive);
    },
    activatorColor() {
      if (this.hasInactive) return "error";
      return "primary";
    },
    decoratedItems() {
      return this.items.map((entry, index) => ({
        ...entry,
        ...this.resolveStatus(entry),
        key: `${index}-${entry.id}`,
        hasInitiative: !!entry.initiative,
        placeholder: entry.isLoading
          ? `Carregando iniciativa #${entry.id}...`
          : `Iniciativa #${entry.id} indisponível`,
      }));
    },
  },
  methods: {
    resolveStatus(entry) {
      if (entry.isLoading) return STATUS_LOADING;
      if (entry.isFailed) return STATUS_FAILED;
      if (entry.isInactive) return STATUS_INACTIVE;
      return STATUS_ACTIVE;
    },
  },
};
</script>
